import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VExpansionPanels,{attrs:{"accordion":"","focusable":""},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},_vm._l((_vm.faqs),function(faq,index){return _c('faq-item',{key:index,attrs:{"question":faq.question,"answer":faq.answer}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }